import React from 'react'
import styles from './Text.module.scss'

type Size = 'inherit' | 'xs' | 'sm' | 'base' | 'lg'
type Weight = 'normal' | 'medium' | 'semibold' | 'bold'
type Color = 'default' | 'muted' | 'primary' | 'success' | 'warning' | 'error'
type As = 'p' | 'span' | 'div' | 'label'

interface TextProps {
  children: React.ReactNode
  size?: Size
  weight?: Weight
  color?: Color
  as?: As
  className?: never
}

const sizeMap: Record<Size, string> = { inherit: styles.inherit, xs: styles.xs, sm: styles.sm, base: styles.base, lg: styles.lg }
const weightMap: Record<Weight, string> = { normal: styles.normal, medium: styles.medium, semibold: styles.semibold, bold: styles.bold }
const colorMap: Record<Color, string> = {
  default: styles.colorDefault, muted: styles.colorMuted, primary: styles.colorPrimary,
  success: styles.colorSuccess, warning: styles.colorWarning, error: styles.colorError,
}

export const Text: React.FC<TextProps> = ({
  children, size = 'base', weight = 'normal', color = 'default', as: Tag = 'p',
}) => (
  <Tag className={[styles.text, sizeMap[size], weightMap[weight], colorMap[color]].join(' ')}>
    {children}
  </Tag>
)
